import type { ComponentPropsWithoutRef } from "react";
import { TooltipContent } from "@repo/ui/components/tooltip";
import { useShellPortalContainer } from "../portal-context";

type ShellTooltipContentProps = ComponentPropsWithoutRef<typeof TooltipContent>;

export function ShellTooltipContent(props: ShellTooltipContentProps) {
  const container = useShellPortalContainer();
  return <TooltipContent container={container ?? undefined} {...props} />;
}
